import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import { TripState } from '../../../types/trips/Trips';
import s from './TripStateIndicatorInbox.module.scss';

type Props = {
  classNameModifier?:string;
  tripState: TripState;
  unread: boolean;
};

const TripStateIndicatorInbox: FC<Props> = ({
  classNameModifier = '',
  tripState,
  unread,
}) => {
  const modifiers = [
    classNameModifier,
    unread ? 'unread' : '',
    tripState?.state ?? '',
  ].join(' ');

  return (
    <li className={getClassName(s, 'root', modifiers)}>
      {tripState?.badge ?? ''}
    </li>
  );
};

export default TripStateIndicatorInbox;
